<template>
  <div class="settings-container">
    <div class="settings-header">
      <div class="header-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="3"/>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
        </svg>
      </div>
      <h1>{{ (isTeacher || isAssistant) && !isAdmin ? 'Tanár Funkciók' : 'Admin Funkciók' }}</h1>
      <p>{{ (isTeacher || isAssistant) && !isAdmin ? 'Csoport kezelés és tartalom' : 'Rendszer beállítások és kezelés' }}</p>
    </div>

    <div class="settings-grid">
      <!-- Left side content area -->
      <div class="settings-content">
        <div class="settings-sections">
          <!-- Management Section -->
          <div class="settings-section">
            <div class="section-header">
              <div class="section-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <h2>{{ isTeacher && !isAdmin ? 'Csoportok' : 'Kezelés' }}</h2>
            </div>
            <div class="function-cards">
              <!-- Groups Card -->
              <div class="function-card">
                <router-link to="/settings/groups" class="function-link" @click="showContent('groups')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                      <circle cx="9" cy="7" r="4"/>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                    </svg>
                  </div>
                  <div class="card-content">
                    <h3>Csoportok</h3>
                    <p>{{ isTeacher && !isAdmin ? 'Hozzárendelt csoportok megtekintése' : 'Csoport hozzáadása és törlése' }}</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>

              <!-- Children Card - For admins, teachers, and assistants -->
              <div v-if="isAdmin || isTeacher || isAssistant" class="function-card">
                <router-link to="/settings/children" class="function-link" @click="showContent('children')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                      <circle cx="12" cy="7" r="4"/>
                    </svg>
                  </div>
                  <div class="card-content">
                    <h3>Táncosok</h3>
                    <p>Táncosok listázása és beállítások</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>

            <!-- Teachers - For admins and assistants -->
            <div v-if="isAdmin || isAssistant" class="function-card">
                <router-link to="/settings/teacher" class="function-link" @click="showContent('teacher')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                      <circle cx="12" cy="7" r="4"/>
                    </svg>
                  </div>
                  <div class="card-content">
                    <h3>Tanárok</h3>
                    <p>Tanárok listázása és beállítások</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>

            <!-- Pricing - Only for admins -->
            <div v-if="isAdmin" class="function-card">
                <router-link to="/settings/pricing" class="function-link" @click="showContent('pricing')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                    </svg>
                  </div>
                  <div class="card-content">
                    <h3>Árazás</h3>
                    <p>Csoport alapárak kezelése</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>

            <!-- Discounts - Only for admins -->
            <div v-if="isAdmin" class="function-card">
                <router-link to="/settings/discounts" class="function-link" @click="showContent('discounts')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
                      <line x1="7" y1="7" x2="7.01" y2="7"/>
                    </svg>
                  </div>
                  <div class="card-content">
                    <h3>Kedvezmények</h3>
                    <p>Táncosok havi díjai és egyedi árak</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>

              <!-- Audit Log - For admins, teachers, and assistants -->
              <div v-if="isAdmin || isTeacher || isAssistant" class="function-card">
                <router-link to="/settings/audit" class="function-link" @click="showContent('audit')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"/>
                    </svg>
                  </div>
                  <div class="card-content">
                    <h3>Tevékenységnapló</h3>
                    <p>Fizetési, óra- és csoportváltozások naplója</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>

          </div>
          </div>
          <!-- Content Section -->
          <div class="settings-section">
            <div class="section-header">
              <div class="section-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14,2 14,8 20,8"/>
                  <line x1="16" y1="13" x2="8" y2="13"/>
                  <line x1="16" y1="17" x2="8" y2="17"/>
                  <polyline points="10,9 9,9 8,9"/>
                </svg>
              </div>
              <h2>Tartalom</h2>
            </div>
            <div class="function-cards">
              <!-- Homeworks Card -->
              <div class="function-card">
                <router-link to="/settings/homeworks" class="function-link" @click="showContent('homeworks')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                      <polyline points="14,2 14,8 20,8"/>
                      <line x1="16" y1="13" x2="8" y2="13"/>
                      <line x1="16" y1="17" x2="8" y2="17"/>
                      <polyline points="10,9 9,9 8,9"/>
                    </svg>
                  </div>
                  <div class="card-content">
                    <h3>Házifeladatok</h3>
                    <p>Házifeladatok listázása</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>

              <!-- Events Card -->
              <div class="function-card">
                <router-link to="/settings/events" class="function-link" @click="showContent('events')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                      <line x1="16" y1="2" x2="16" y2="6"/>
                      <line x1="8" y1="2" x2="8" y2="6"/>
                      <line x1="3" y1="10" x2="21" y2="10"/>
                    </svg>
                  </div>
                  <div class="card-content">
                    <h3>Táncóra napló</h3>
                    <p>Táncórák listázása</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <!-- Registration Section - Only for admins -->
          <div v-if="isAdmin || isTeacher" class="settings-section">
            <div class="section-header">
              <div class="section-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="8.5" cy="7" r="4"/>
                  <line x1="20" y1="8" x2="20" y2="14"/>
                  <line x1="23" y1="11" x2="17" y2="11"/>
                </svg>
              </div>
              <h2>Regisztráció</h2>
            </div>
            <div class="function-cards">
              <!-- Registration Card -->
              <div class="function-card">
                <router-link to="/settings/reg" class="function-link" @click="showContent('reg')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                      <circle cx="8.5" cy="7" r="4"/>
                      <line x1="20" y1="8" x2="20" y2="14"/>
                      <line x1="23" y1="11" x2="17" y2="11"/>
                    </svg>
                  </div>
                  <div class="card-content">
                    <h3>Regisztráció</h3>
                    <p>Regisztrációs link kiküldése</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>

              <!-- Registration Queue Card -->
              <div class="function-card">
                <router-link to="/settings/regqueue" class="function-link" @click="showContent('regqueue')">
                  <div class="card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-6m8 0V9a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v4.01"/>
                    </svg>
                  </div>
                  <div class="card-content">
                    <h3>Regisztráció sorrend</h3>
                    <p>Táncos regisztrálási sorrendje</p>
                  </div>
                  <div class="card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right side calendar -->
      <div class="calendar-sidebar">
        <calendar-item />
      </div>
    </div>

    <!-- Overlay when floating content is open -->
    <div v-if="activeContent" class="overlay" @click="closeContent"></div>

    <!-- Floating content area -->
    <div v-if="activeContent" class="floating-content">
      <div class="floating-header">
        <h2>{{ activeTitle }}</h2>
        <button class="close-btn" @click="closeContent">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
      <div class="floating-body">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
// Importing the calendar component
import CalendarItem from './CalendarItem.vue';

export default {
  components: {
    CalendarItem
  },
  data() {
    return {
      activeContent: null,
      isAdmin: false,
      isTeacher: false,
      isAssistant: false
    };
  },
  computed: {
    activeTitle() {
      const titleMap = {
        groups: 'Csoportok',
        children: 'Táncosok',
        teacher: 'Tanárok',
        pricing: 'Árak és Díjak',
        billing: 'Számlázási Beállítások',
        discounts: 'Kedvezmények & Egyedi Díjak',
        audit: 'Tevékenységnapló',
        homeworks: 'Házi Feladatok',
        events: 'Események',
        reg: 'Új Regisztráció',
        regqueue: 'Regisztrációs Várólista'
      };
      return titleMap[this.activeContent] || 'Beállítások';
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler(to) {
        this.updateActiveContent(to);
      }
    }
  },
  methods: {
    updateActiveContent(route = this.$route) {
      if (route && route.path && route.path.startsWith('/settings/')) {
        const sub = route.path.replace('/settings/', '').split('/')[0];
        this.activeContent = sub || null;
      } else {
        this.activeContent = null;
      }
    },
    getIsAdmin() {
      this.isAdmin = this.$isAdmin();
    },
    getIsTeacher() {
      this.isTeacher = this.$isTeacher();
    },
    getIsAssistant() {
      this.isAssistant = this.$isAssistant();
    },
    showContent(content) {
      this.activeContent = content; // Set the active content based on the clicked card
    },
    closeContent() {
      this.activeContent = null; // Close the floating content when X is clicked
      if (this.$route.path !== '/settings') {
        this.$router.push('/settings');
      }
    }
  },
  mounted() {
    this.getIsAdmin();
    this.getIsTeacher();
    this.getIsAssistant();
    this.updateActiveContent(this.$route);
  }
};
</script>

<style scoped>
.settings-container {
  min-height: 100vh;
  padding: 2rem 1rem;
  max-width: 1400px;
  margin: 0 auto;
}

.settings-header {
  background: linear-gradient(135deg, var(--primary-blue) 0%, var(--secondary-blue) 100%);
  border-radius: 16px;
  padding: 1.25rem 1.5rem;
  color: white;
  text-align: center;
  box-shadow: var(--shadow-lg);
  position: relative;
  overflow: hidden;
  margin-bottom: 2rem;
}

.settings-header::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

.header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  margin-bottom: 0.5rem;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  position: relative;
  z-index: 1;
}

.settings-header h1 {
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
}

.settings-header p {
  font-size: 0.95rem;
  opacity: 0.9;
  margin: 0;
  font-weight: 500;
  position: relative;
  z-index: 1;
}

.settings-grid {
  display: grid;
  grid-template-columns: 1fr 350px;
  gap: 2rem;
  align-items: start;
}

.settings-content {
  min-height: 500px;
}

.settings-sections {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.settings-section {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow);
  border: 1px solid var(--color-border);
  overflow: hidden;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 2rem;
  background: var(--color-background-mute);
  border-bottom: 1px solid var(--color-border);
}

.section-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  border-radius: 8px;
  color: white;
  flex-shrink: 0;
}

.section-header h2 {
  color: var(--color-heading);
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.function-cards {
  padding: 1.5rem;
  display: grid;
  gap: 1rem;
}

.function-card {
  background: var(--color-background-mute);
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--color-border);
  transition: all 0.3s ease;
  overflow: hidden;
}

.function-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
  border-color: var(--primary-blue);
  background: var(--card-bg);
}

.function-link {
  display: flex;
  align-items: center;
  padding: 1.5rem;
  text-decoration: none;
  color: inherit;
  gap: 1.5rem;
  transition: all 0.3s ease;
}

.function-link:hover {
  text-decoration: none;
  color: inherit;
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  border-radius: 12px;
  color: white;
  flex-shrink: 0;
  box-shadow: var(--shadow-sm);
}

.card-content {
  flex: 1;
}

.card-content h3 {
  color: var(--color-heading);
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
}

.card-content p {
  color: var(--color-text-muted);
  font-size: 0.95rem;
  margin: 0;
  line-height: 1.4;
}

.card-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: var(--color-background-mute);
  border-radius: 50%;
  color: var(--primary-blue);
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.function-card:hover .card-arrow {
  background: var(--primary-blue);
  color: white;
  transform: translateX(4px);
}

.calendar-sidebar {
  position: sticky;
  top: 2rem;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1040;
  backdrop-filter: blur(4px);
  transition: all 0.3s ease;
}

.floating-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 1000px;
  max-height: 80vh;
  background: var(--card-bg);
  border-radius: 20px;
  box-shadow: var(--shadow-xl);
  border: 1px solid var(--color-border);
  z-index: 1050;
  overflow: hidden;
  transition: all 0.3s ease;
}

.floating-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background: var(--color-background-mute);
  border-bottom: 1px solid var(--color-border);
}

.floating-header h2 {
  color: var(--color-heading);
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: var(--color-background-mute);
  border: 1px solid var(--color-border);
  border-radius: 50%;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: var(--error);
  color: white;
  border-color: var(--error);
  transform: scale(1.1);
}

.floating-body {
  padding: 2rem;
  max-height: calc(80vh - 80px);
  overflow-y: auto;
}

/* Responsive design */
@media (max-width: 1024px) {
  .settings-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .calendar-sidebar {
    position: static;
    order: -1;
  }
}

@media (max-width: 768px) {
  .settings-container {
    padding: 1rem 0.75rem;
  }
  
  .settings-header {
    padding: 1.5rem;
    border-radius: 12px;
    margin-bottom: 2rem;
  }
  
  .settings-header h1 {
    font-size: 2rem;
  }
  
  .settings-header p {
    font-size: 1rem;
  }
  
  .section-header {
    padding: 1rem 1.5rem;
  }
  
  .section-header h2 {
    font-size: 1.25rem;
  }
  
  .function-cards {
    padding: 1rem;
  }
  
  .function-link {
    padding: 1.25rem;
    gap: 1rem;
  }
  
  .card-icon {
    width: 50px;
    height: 50px;
  }
  
  .card-content h3 {
    font-size: 1.125rem;
  }
  
  .card-content p {
    font-size: 0.875rem;
  }
  
  .floating-content {
    width: 95%;
    max-height: 85vh;
  }
  
  .floating-header {
    padding: 1rem 1.5rem;
  }
  
  .floating-header h2 {
    font-size: 1.25rem;
  }
  
  .floating-body {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .settings-container {
    padding: 0.75rem 0.5rem;
  }
  
  .settings-header {
    padding: 1.25rem;
    border-radius: 10px;
  }
  
  .settings-header h1 {
    font-size: 1.75rem;
  }
  
  .section-header {
    padding: 0.75rem 1rem;
  }
  
  .section-header h2 {
    font-size: 1.125rem;
  }
  
  .function-cards {
    padding: 0.75rem;
  }
  
  .function-link {
    padding: 1rem;
    gap: 0.75rem;
  }
  
  .card-icon {
    width: 45px;
    height: 45px;
  }
  
  .card-content h3 {
    font-size: 1rem;
  }
  
  .card-content p {
    font-size: 0.8rem;
  }
  
  .card-arrow {
    width: 35px;
    height: 35px;
  }
  
  .floating-content {
    width: 98%;
    max-height: 90vh;
    border-radius: 16px;
  }
  
  .floating-header {
    padding: 0.75rem 1rem;
  }
  
  .floating-header h2 {
    font-size: 1.125rem;
  }
  
  .floating-body {
    padding: 1rem;
  }
}
</style>
